import React, { useState } from "react";
import { apiCall, getErrorMessage } from "../../utils/api";

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [errorInfo, setErrorInfo] = useState(null); // Store error with request ID

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const validate = () => {
    if (!form.name.trim()) return false;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return false;
    if (!form.subject.trim()) return false;
    if (!form.message.trim()) return false;
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setStatus("error");
      setErrorInfo({ message: "Please fill in all fields correctly" });
      return;
    }
    setSending(true);
    setStatus(null);
    setErrorInfo(null);
    try {
      // Use new API utility - automatically uses API_BASE_URL from env
      await apiCall("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      setStatus("success");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error sending contact form:", error);
      setStatus("error");
      setErrorInfo({
        message: getErrorMessage(error),
        requestId: error.requestId
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="bg-[#f8fafc] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 py-12">
        <h2 className="text-2xl md:text-3xl font-bold text-[#3C0F6C] mb-6">Get in touch</h2>
        <form
          onSubmit={onSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-6 rounded-2xl shadow border border-gray-100"
        >
          <input
            name="name"
            value={form.name}
            onChange={onChange}
            placeholder="Name"
            className="px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={onChange}
            placeholder="Email"
            className="px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <input
            name="subject"
            value={form.subject}
            onChange={onChange}
            placeholder="Subject"
            className="md:col-span-2 px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <textarea
            name="message"
            value={form.message}
            onChange={onChange}
            placeholder="Message"
            rows={5}
            className="md:col-span-2 px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3C0F6C]/40"
          />
          <div className="md:col-span-2">
            <button
              disabled={sending}
              className="px-6 py-3 rounded-xl bg-[#3C0F6C] text-white font-semibold disabled:opacity-60"
            >
              {sending ? "Sending…" : "Send Message"}
            </button>
            {status === "success" && (
              <div className="mt-4 text-green-600 text-sm">✅ Message sent successfully!</div>
            )}
            {status === "error" && errorInfo && (
              <div className="mt-4 text-red-600 text-sm">
                <div>❌ {errorInfo.message}</div>
                {errorInfo.requestId && (
                  <div className="text-xs mt-1 font-mono opacity-75">
                    Reference ID: {errorInfo.requestId}
                  </div>
                )}
              </div>
            )}
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;